import { Routes } from '@angular/router';
import { AffiliationViewComponent } from '@components/crt/components/affiliation-view/affiliation-view.component';
import { SearchProfileComponent } from '@components/crt/components/search-profile/search-profile.component';
import { MainComponent } from '@components/main/components/main/main.component';
import { PageNotFoundComponent } from '@error/components/page-not-found/page-not-found.component';
import { LandingComponent } from '@landing/landing.component';
import { AffiliationGraphComponent } from '@components/crt/components/affiliation-view/affiliation-graph/affiliation-graph.component';

// export const routes: Routes = [
//   { path: '', component: LandingComponent },
//   { path: 'home', component: LandingComponent },
//   {
//     path: 'main', component: MainComponent,
//     children: [
//       {
//         path: 'crt', children: [
//            { path: '', component: SearchProfileComponent },
//           { path: 'search', component: SearchProfileComponent },
//           { path: 'affiliationView', component: AffiliationViewComponent },
//           { path: 'affiliation-graph', component: AffiliationGraphComponent },
//           { path: '**', component: PageNotFoundComponent },
//         ]
//       }
//     ]
//   },
// ];

export const routes: Routes = [
  { path: '', component: LandingComponent },
  { path: 'home', component: LandingComponent },

  {
    path: 'main',
    component: MainComponent,
    children: [
      { path: '', redirectTo: 'crt', pathMatch: 'full' },

      {
        path: 'crt',
        children: [
          { path: '', component: SearchProfileComponent },
          { path: 'search', component: SearchProfileComponent },
          { path: 'affiliationView', component: AffiliationViewComponent },
          { path: 'affiliation-graph', component: AffiliationGraphComponent },
        ]
      }
    ]
  },

  { path: '**', component: PageNotFoundComponent }
];
